import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import { MdCampaign } from "react-icons/md";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

import {
  Avatar,
  Divider,
  Fade,
  Menu,
  MenuItem,
  Stack,
  Typography,
  alpha,
} from "@mui/material";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";

import { useLocation, useNavigate } from "react-router-dom";
import NotificationsDropdown from "../../components/mui/NotificationsDropdown";
import { useDispatch } from "react-redux";
import { userLogout } from "../../actions/userAuth";
import { clearAuthorization, logoutUser } from "../../utils/api";
import { useSelector } from "react-redux";
import { enqueueSnackbar } from "notistack";
import { LiaUsersSolid } from "react-icons/lia";
import { IoTicketOutline } from "react-icons/io5";
import { Diversity3, SettingsOutlined, ContactSupportOutlined, CurrencyExchangeOutlined, InsightsOutlined, ExploreOutlined, LoyaltyOutlined } from "@mui/icons-material";
const drawerWidth = 280;

const drawerPaperSx = {
  width: drawerWidth,
  boxSizing: "border-box",
  height: "100vh",
  maxHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  background:
    "linear-gradient(180deg, #060a12 0%, #0c1222 40%, #0f172a 100%)",
  borderRight: "1px solid rgba(255, 255, 255, 0.06)",
  boxShadow: "4px 0 40px rgba(0, 0, 0, 0.15)",
};

const drawerNavScrollSx = {
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
  overflowX: "hidden",
  px: 1.5,
  py: 0,
  position: "relative",
  zIndex: 1,
  "&::-webkit-scrollbar": { width: 6 },
  "&::-webkit-scrollbar-thumb": {
    background: "rgba(255,255,255,0.12)",
    borderRadius: 8,
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent",
  },
};

const drawerItems = [
  {
    icon: <img src="/home2.svg" alt="Dashboard" />,
    icon2: <img src="/home.svg" alt="Dashboard" />,
    text: "Dashboard",
    LinkUrl: "/dashboard",
  },
  {
    icon: <img src="/user2.svg" alt="User" />,
    icon2: <img src="/user.svg" alt="User" />,
    text: "User",
    LinkUrl: "/user",
  },
  {
    icon: <img src="/Transations2.svg" alt="Transactions" />,
    icon2: <img src="/Transactions.svg" alt="Transactions" />,
    text: "Transactions",
    LinkUrl: "/transactions",
  },
  {
    icon: <CurrencyExchangeOutlined />,
    icon2: <CurrencyExchangeOutlined />,
    text: "Refund & retry Management",
    LinkUrl: "/refund-management",
  },
  {
    icon: <InsightsOutlined />,
    icon2: <InsightsOutlined />,
    text: "Revenue Analytics",
    LinkUrl: "/revenue-analytics",
  },
  
  {
    icon: <img src="/bBrandManagement.svg" alt="Transactions" />,
    icon2: <img src="/brandmanag.svg" alt="Transactions" />,
    text: "Brand Management",
    LinkUrl: "/brand-management",
  },
  

  {
    icon: <img src="/bBackendUser.svg" alt="Transactions" />,
    icon2: <img src="/clientmang.svg" alt="Transactions" />,
    text: "Backend User",
    LinkUrl: "/backend-user",
  },
  {
    icon: <img src="/bBannermanagement.svg" alt="Transactions" />,
    icon2: <img src="/backenduser.svg" alt="Transactions" />,
    text: "Banner Management",
    LinkUrl: "/Banner-management",
  },
  {
    icon: <LoyaltyOutlined />,
    icon2: <LoyaltyOutlined color="primary" />,
    text: "Featured Voucher",
    LinkUrl: "/featured-voucher",
  },
  {
    icon: <IoTicketOutline width={"12rem"} />,
    icon2: <IoTicketOutline />,
    text: "Ticket Management",
    LinkUrl: "/ticket-management",
  },
  {
    icon: <ContactSupportOutlined />,
    icon2: <ContactSupportOutlined />,
    text: "Support Query",
    LinkUrl: "/support-query",
  },

  {
    icon: <EmojiEventsIcon width={"12rem"} />,
    icon2: <EmojiEventsIcon color="blue" />,
    text: "Reward Management",
    LinkUrl: "/reward-management",
  },
  {
    icon: <LiaUsersSolid width={"12rem"} fontSize={"2rem"} />,
    icon2: <LiaUsersSolid fontSize={"2rem"} />,
    text: "Campaign Leads ",
    LinkUrl: "/campaign-leads",
  },
  {
    icon: <Diversity3 width={"12rem"} fontSize={"large"} />,
    icon2: <Diversity3 fontSize={"large"} />,
    text: "Budgetree Leads ",
    LinkUrl: "/budgetree-leads",
  },
  {
    icon: <ExploreOutlined />,
    icon2: <ExploreOutlined color="primary" />,
    text: "Experiences",
    LinkUrl: "/experiences",
  },
  {
    icon: <SettingsOutlined />,
    icon2: <SettingsOutlined />,
    text: "Settings",
    LinkUrl: "/settings",
  },
];

const ROLE_ROUTE_MAP = {
  "Client management": ["/business-user", "/client-detail"],
  "Order management": ["/transactions", "/order-management", "/refund-management", "/revenue-analytics", "/user-orders", "/users-orders", "/experiences", "/experiences/orders"],
  "Brand management": ["/user", "/brand-management", "/discount-coupon", "/Banner-management", "/featured-voucher", "/user-orders", "/users-orders", "/blacklist", "/user-blacklist", "/fraud-users", "/experiences", "/experiences/orders"],
  "Ticket management": ["/ticket-management"],
  "Sales management": ["/sales-management"],
  "Banner management": ["/Banner-management", "/featured-voucher"],
};

const ADMIN_BASE_ROUTES = [
  "/dashboard",
  "/settings",
  "/support-query",
  "/refund-management",
  "/revenue-analytics",
  "/user-orders",
  "/users-orders",
  "/blacklist",
  "/user-blacklist",
  "/fraud-users",
  "/experiences",
  "/experiences/orders",
  "/featured-voucher",
];

function HomeLayout(props) {
  const { window, children } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const Navigator = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.user);
  const userRole = localStorage.getItem("SiriAdminUserRole");
  const normalizedUserRole = (userRole || "").toUpperCase();

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      Navigator("/");
    }
  }, [Navigator]);

  const handleNotificationClose = () => {
    setAnchorEl(null);
    setNotificationOpen(false);
  };

  const userAccessList = useMemo(
    () =>
      Array.isArray(user?.hasAccessTo)
        ? user.hasAccessTo
        : user?.hasAccessTo
        ? [user.hasAccessTo]
        : [],
    [user?.hasAccessTo]
  );

  const allowedRouteSet = useMemo(() => {
    if (normalizedUserRole === "SUPERADMIN") {
      return new Set([
        ...drawerItems.map((item) => item.LinkUrl),
        "/client-detail",
        "/user-orders",
        "/users-orders",
        "/order-management",
        "/blacklist",
        "/user-blacklist",
        "/fraud-users",
      ]);
    }
    if (normalizedUserRole === "ADMIN") {
      return new Set([
        ...ADMIN_BASE_ROUTES,
        ...userAccessList.flatMap((role) => ROLE_ROUTE_MAP[role] || []),
      ]);
    }
    return new Set();
  }, [normalizedUserRole, userAccessList]);

  const filteredDrawerItems = drawerItems.filter((item) =>
    allowedRouteSet.has(item.LinkUrl)
  );
  const isActive = (linkUrl) => {
    if (location.pathname === linkUrl) return true;
    if (
      linkUrl === "/user" &&
      (location.pathname === "/blacklist" ||
        location.pathname === "/user-blacklist" ||
        location.pathname === "/fraud-users")
    ) {
      return true;
    }
    return false;
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [anchorEl1, setAnchorEl1] = useState(null);
  const open = Boolean(anchorEl1);

  const handleClick = (event) => {
    setAnchorEl1(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl1(null);
  };

  const handleLogout = () => {
    dispatch(
      userLogout(
        {},
        () => {
          logoutUser();
        },
        () => {
          logoutUser();
        }
      )
    );
  };

  const renderNavIcon = (item, active) => {
    const icon = active ? item.icon : item.icon2;
    if (React.isValidElement(icon) && icon.props?.src) {
      return (
        <Box
          component="img"
          src={icon.props.src}
          alt={icon.props.alt || ""}
          sx={{
            width: 22,
            height: 22,
            objectFit: "contain",
            filter: active
              ? "brightness(0) invert(1)"
              : "brightness(0) invert(0.55)",
            transition: "filter 0.2s",
          }}
        />
      );
    }
    return (
      <Box
        sx={{
          color: active ? "#fff" : "rgba(255,255,255,0.45)",
          display: "flex",
          alignItems: "center",
          fontSize: 22,
          "& svg": { fontSize: 22 },
        }}
      >
        {icon}
      </Box>
    );
  };

  const drawer = (
    <Box
      sx={{
        height: "100%",
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Ambient glow */}
      <Box
        sx={{
          position: "absolute",
          top: -80,
          left: -60,
          width: 200,
          height: 200,
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(37,99,235,0.25) 0%, transparent 70%)",
          pointerEvents: "none",
        }}
      />

      {/* Logo + section label — fixed header */}
      <Box sx={{ flexShrink: 0, position: "relative", zIndex: 1 }}>
        <Box sx={{ px: 2.5, pt: 3, pb: 2 }}>
          <Box
            onClick={() => Navigator("/dashboard")}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 1.5,
              borderRadius: "14px",
              bgcolor: "#ffffff",
              boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
              cursor: "pointer",
              transition: "transform 0.2s, box-shadow 0.2s",
              "&:hover": {
                transform: "translateY(-1px)",
                boxShadow: "0 6px 20px rgba(0, 0, 0, 0.28)",
              },
            }}
          >
            <Box
              component="img"
              src="https://siripay.co/logo.png"
              alt="SiriPay"
              onError={(e) => {
                e.currentTarget.src = "/logo.png";
              }}
              sx={{
                height: 34,
                width: "auto",
                maxWidth: "100%",
                objectFit: "contain",
                display: "block",
              }}
            />
          </Box>
        </Box>

        <Divider sx={{ borderColor: "rgba(255,255,255,0.06)", mx: 2 }} />

        <Typography
          variant="caption"
          sx={{
            px: 3,
            pt: 2.5,
            pb: 1,
            color: "rgba(255,255,255,0.35)",
            fontWeight: 600,
            letterSpacing: "0.12em",
            fontSize: "0.65rem",
          }}
        >
          NAVIGATION
        </Typography>
      </Box>

      <Box sx={drawerNavScrollSx}>
        <List sx={{ py: 0 }}>
        {filteredDrawerItems.map((item, index) => {
          const active = isActive(item.LinkUrl);
          return (
            <ListItem disablePadding key={item.LinkUrl || index} sx={{ mb: 0.5 }}>
              <ListItemButton
                onClick={() => {
                  Navigator(item.LinkUrl);
                  handleDrawerClose();
                }}
                sx={{
                  borderRadius: "14px",
                  py: 1.25,
                  px: 1.5,
                  position: "relative",
                  overflow: "hidden",
                  transition: "all 0.25s ease",
                  ...(active
                    ? {
                        background:
                          "linear-gradient(135deg, rgba(17,64,155,0.9) 0%, rgba(37,99,235,0.85) 100%)",
                        boxShadow:
                          "0 8px 24px rgba(37, 99, 235, 0.35), inset 0 1px 0 rgba(255,255,255,0.15)",
                        "&:hover": {
                          background:
                            "linear-gradient(135deg, rgba(17,64,155,1) 0%, rgba(37,99,235,0.95) 100%)",
                        },
                      }
                    : {
                        "&:hover": {
                          bgcolor: "rgba(255,255,255,0.06)",
                        },
                      }),
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 40,
                    color: "inherit",
                  }}
                >
                  {renderNavIcon(item, active)}
                </ListItemIcon>
                <ListItemText
                  primary={item.text}
                  primaryTypographyProps={{
                    fontSize: "0.9rem",
                    fontWeight: active ? 600 : 500,
                    color: active ? "#fff" : "rgba(255,255,255,0.55)",
                    noWrap: true,
                  }}
                />
                {active && (
                  <ChevronRightRoundedIcon
                    sx={{ fontSize: 18, color: alpha("#fff", 0.7) }}
                  />
                )}
              </ListItemButton>
            </ListItem>
          );
        })}
        </List>
      </Box>

      {/* Footer user + logout — fixed at bottom */}
      <Box
        sx={{
          flexShrink: 0,
          p: 2,
          position: "relative",
          zIndex: 1,
        }}
      >
        <Box
          sx={{
            p: 1.75,
            borderRadius: "16px",
            background: alpha("#fff", 0.04),
            border: "1px solid rgba(255,255,255,0.08)",
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Avatar
              sx={{
                width: 40,
                height: 40,
                bgcolor: "linear-gradient(135deg, #11409B, #2563eb)",
                fontSize: "0.9rem",
                fontWeight: 700,
              }}
            >
              {(user?.name?.[0] || user?.email?.[0] || "A").toUpperCase()}
            </Avatar>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                noWrap
                sx={{
                  color: "#f1f5f9",
                  fontWeight: 600,
                  fontSize: "0.85rem",
                }}
              >
                {user?.name || user?.email || "Admin"}
              </Typography>
              <Box
                sx={{
                  display: "inline-block",
                  mt: 0.5,
                  px: 1,
                  py: 0.15,
                  borderRadius: "6px",
                  bgcolor: alpha("#38bdf8", 0.15),
                  border: `1px solid ${alpha("#38bdf8", 0.25)}`,
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    color: "#7dd3fc",
                    fontWeight: 600,
                    fontSize: "0.65rem",
                    letterSpacing: "0.04em",
                  }}
                >
                  {normalizedUserRole || "ADMIN"}
                </Typography>
              </Box>
            </Box>
          </Stack>

          <ListItemButton
            onClick={handleLogout}
            sx={{
              mt: 1.5,
              borderRadius: "12px",
              py: 1,
              color: "rgba(255,255,255,0.55)",
              "&:hover": {
                bgcolor: alpha("#ef4444", 0.12),
                color: "#fca5a5",
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 36, color: "inherit" }}>
              <LogoutOutlinedIcon sx={{ fontSize: 20 }} />
            </ListItemIcon>
            <ListItemText
              primary="Sign out"
              primaryTypographyProps={{ fontSize: "0.85rem", fontWeight: 500 }}
            />
          </ListItemButton>
        </Box>
      </Box>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/");
      return;
    }
    const currentRoute = location.pathname;
    const canAccessClientDetail =
      allowedRouteSet.has("/client-detail") &&
      currentRoute.startsWith("/client-detail");
    const hasAccess = allowedRouteSet.has(currentRoute) || canAccessClientDetail;

    if (!hasAccess) {
      enqueueSnackbar("You do not have permission to access this page!", {
        variant: "error",
      });
      setTimeout(() => {
        Navigator("/dashboard");
      }, 1500);
    }
  }, [location.pathname, allowedRouteSet, userRole, Navigator, enqueueSnackbar, navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        height: "auto",
      }}
    >
      <CssBaseline />
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          width: { md: `calc(100% - ${drawerWidth}px)` },
          ml: { md: `${drawerWidth}px` },
          backgroundColor: alpha("#fff", 0.85),
          backdropFilter: "blur(12px)",
          borderBottom: "1px solid",
          borderColor: alpha("#11409B", 0.08),
          boxShadow: "0 4px 24px rgba(15, 23, 42, 0.04)",
        }}
      >
        <Toolbar sx={{ minHeight: { xs: 64, md: 72 } }}>
          <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{
              mr: 2,
              display: { md: "none" },
              color: "#11409B",
              bgcolor: alpha("#11409B", 0.08),
              "&:hover": { bgcolor: alpha("#11409B", 0.14) },
            }}
          >
            <MenuIcon />
          </IconButton>

          <Box
            component="img"
            src="https://siripay.co/logo.png"
            alt="SiriPay"
            onClick={() => Navigator("/dashboard")}
            onError={(e) => {
              e.currentTarget.src = "/logo.png";
            }}
            sx={{
              height: 28,
              width: "auto",
              objectFit: "contain",
              display: { xs: "block", md: "none" },
              cursor: "pointer",
              mr: 2,
            }}
          />

          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "end",
            }}
          >
            <Box>
              <IconButton
                size="small"
                edge="end"
                aria-label="account of current user"
                id="demo-positioned-menu"
                aria-controls={open ? "demo-positioned-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                sx={{
                  p: 0.5,
                  border: "2px solid",
                  borderColor: alpha("#11409B", 0.15),
                  "&:hover": { borderColor: "#11409B" },
                }}
              >
                <Avatar
                  sx={{
                    width: 40,
                    height: 40,
                    bgcolor: "linear-gradient(135deg, #11409B, #2563eb)",
                    fontSize: "0.95rem",
                    fontWeight: 700,
                  }}
                >
                  {(user?.name?.[0] || user?.email?.[0] || "A").toUpperCase()}
                </Avatar>
              </IconButton>
              <Menu
                id="fade-menu"
                MenuListProps={{
                  "aria-labelledby": "fade-button",
                }}
                anchorEl={anchorEl1}
                open={open}
                TransitionComponent={Fade}
                onClose={handleMenuClose}
                PaperProps={{
                  sx: {
                    mt: 1,
                    borderRadius: "14px",
                    minWidth: 160,
                    boxShadow: "0 12px 40px rgba(15,23,42,0.12)",
                    border: "1px solid",
                    borderColor: alpha("#11409B", 0.08),
                  },
                }}
              >
                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    handleLogout();
                  }}
                  sx={{
                    py: 1.25,
                    color: "#dc2626",
                    fontWeight: 500,
                    gap: 1,
                  }}
                >
                  <LogoutOutlinedIcon sx={{ fontSize: 18 }} />
                  Logout
                </MenuItem>
              </Menu>

              <NotificationsDropdown
                open={notificationOpen}
                onClose={handleNotificationClose}
                anchorEl={anchorEl}
              />
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{
          width: { md: drawerWidth },
          flexShrink: { md: 0 },
        }}
        aria-label="mailbox folders"
      >
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": drawerPaperSx,
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", md: "block" },
            "& .MuiDrawer-paper": drawerPaperSx,
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          background: "transparent",
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            width: "0",
          },
          scrollbarWidth: "none",
        }}
      >
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
}

HomeLayout.propTypes = {
  window: PropTypes.func,
  children: PropTypes.node,
};

export default HomeLayout;
